
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/june-2019-update",
      function () {
        return require("private-next-pages/blog/june-2019-update.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/june-2019-update"])
      });
    }
  